import connection from "../../utils/connection";

const getEstadosPermitidos = async () => {
  let response = {};
  try {
    const responseGet = await connection({
      url: `/estado_turno/estados-permitidos`,
    });

    response.data = responseGet;
  } catch (error) {
    console.error("catch service", error);
    response = error.response;
  }

  return response;
};  

export default getEstadosPermitidos;
